import { Component, OnInit } from '@angular/core';
import { PlotsService} from '../plots.service';
import { Plot } from '../models/plot.model';
import { DataTableDirective } from '../../../shared/directives/data-table.directive';
import { FormBuilder, Validators } from '@angular/forms';
import { ColumnConfig } from '../../../shared/models/column-config.model';
import { ActivatedRoute, Router } from '@angular/router';
import { TitleService } from '../../../shared/services/title.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { PageStateManagerService } from '../../../shared/services/page-state-manager.service';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-plots-list',   
  templateUrl: '../../../shared/templates/data-table.component.html',  
  standalone: false
})
export class PlotsListComponent extends DataTableDirective<Plot> implements OnInit {
  
  columns: ColumnConfig[] = [];

  modelName = 'Plot';  
 
  constructor(
    plotsService: PlotsService, 
    fb: FormBuilder, 
    route: ActivatedRoute, 
    router: Router, 
    titleService: TitleService,
    notificationService: NotificationService,
    pageStateManager: PageStateManagerService,
    authService: AuthService,
  ) {
    super(
      plotsService, 
      fb, 
      route, 
      router, 
      titleService, 
      notificationService,
      pageStateManager,
      authService
    );       
  }

  override ngOnInit(): void {    
    this.columns = [
      { 
        name: 'plotNumber', 
        label: 'Plot Number', 
        inputType: 'text',
        validators: [Validators.required],
        errorMessages: { required: 'Plot Number is required' } 
      },
      { 
        name: 'area', 
        label: 'Area (M<span class="superscript">2</span>)', 
        inputType: 'number',
        validators: [Validators.required],
        errorMessages: { required: 'Area is required' } 
      },
      { 
        name: 'cost', 
        label: 'Cost', 
        inputType: 'currency',
        validators: [Validators.required],
        errorMessages: { required: 'Cost is required' } 
      },
      {
        name: 'id',
        label: 'Items',
        inputType: 'link',
        linkRoute: ['/plots', ':param', 'items'],
      }
    ];
    super.ngOnInit();
  }
}
